module.exports = __webpack_public_path__ + "img/logo-full.7d578b57.png";